import { Component } from '@angular/core';
import { MessagesService } from '../../../service/messages.service';
import { serverurl } from '../../../../environments/environment';

@Component({
  selector: 'rr-messages',
  standalone: false,
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.scss'
})
export class MessagesComponent {
  messages: any[] = [];
  serverurl = serverurl;
  unreadCounter = 0;
  constructor(
    private ms: MessagesService
  ) {
    ms.allUnreadMessages.subscribe((data: any[]) => {
      this.unreadCounter = data.filter((msg) => msg.isRead === 0).length;
      data.forEach((msg) => {
        let exists = this.messages.find((m) => m.id === msg.id);
        if (!exists) {
          this.messages.push(msg);
        }
      });
    });
  }

  setUnreadCounter() {
    this.unreadCounter = this.messages.filter((msg) => msg.isRead === 0).length;
  }

  async deleteMessage(message: any) {
    let result = await this.ms.deleteMessage(message.id);
    if (result !== false) {
      this.messages = this.messages.filter((msg) => msg.id !== message.id);
      this.setUnreadCounter();
    }
  }
  async markAsReadAndOpen(message: any) {
    if (message.isRead === 0) {
      let result = await this.ms.updateReadStatus(message.id);
      this.setUnreadCounter();
      if (result !== false) {
        message.isRead = 1;
        message.open = true;
      }
    } else {
      message.open = false;
    }
  }

  setAllToClosed() {
    console.log('SET ALL TO CLOSED');

    this.messages.forEach((msg) => {
      msg.open = false;
    });
    this.setUnreadCounter();
  }
}
